import { DateFilters, PriorityEnum, TaskStatus, TaskStatusFilter } from "data/constants";
import { getFinancialYears } from "utils/getFinancialYears";

type Filter = {
  title: string;
  key: string;
  options: Array<{ label: string; value: string }>;
};

export const getFilters = ({ users, partners = [] }): Filter[] => {
  return [
    {
      title: "Financial Year",
      key: "financialYear",
      options: getFinancialYears().map((year: string) => ({
        label: year,
        value: year
      }))
    },
    {
      title: "Task Status",
      key: "status",
      options: Object.values(TaskStatusFilter).map((item) => ({
        label: item,
        value: item,
      })),
    },
    {
      title: "Priority",
      key: "priority",
      options: Object.values(PriorityEnum).map((item) => ({
        label: item,
        value: item,
      })),
    },
    {
      title: "Partner",
      key: "partner",
      options: (partners || []).map((item: any) => ({
        label: item?.status === "INACTIVE" ? `${item?.fullName} (Inactive)` : item?.fullName,
        value: item?.id?.toString(),
      })),
    },
    {
      title: "Task Leader",
      key: "taskLeader",
      options: users?.data?.map((item: any) => ({
        label: item?.fullName,
        value: item?.id?.toString(),
      })),
    },
    {
      title: "Assignee",
      key: "assignee",
      options: users?.data?.map((item: any) => ({
        label: item?.fullName,
        value: item?.id.toString(),
      })),
    },
    {
      title: "Start Date",
      key: "startDate",
      options: Object.values(DateFilters).map((item) => ({
        label: item,
        value: item,
      })),
    },
    {
      title: "Statutory Due Date",
      key: "dueOn",
      options: Object.values(DateFilters).map((item) => ({
        label: item,
        value: item,
      })),
    },
    {
      title: "Expected Completion Date",
      key: "expectedCompletionDate",
      options: Object.values(DateFilters).map((item) => ({
        label: item,
        value: item,
      }))
    },
    {
      title: "Created by",
      key: "createdBy",
      options: users?.data?.map((item: any) => ({
        label: item?.fullName,
        value: item?.id?.toString(),
      })),
    },
    {
      title: "Created on",
      key: "createdOn",
      options: Object.values(DateFilters).map((item) => ({
        label: item,
        value: item,
      })),
    },
    {
      title: "Completed by",
      key: "completedBy",
      options: users?.data?.map((item: any) => ({
        label: item?.fullName,
        value: item?.id?.toString(),
      })),
    },
    {
      title: "Billing Type",
      key: "billable",
      options: [
        {
          label: "Billable",
          value: "billable",
        },
        {
          label: "Non-Billable",
          value: "nonbillable",
        },
      ],
    },
    {
      title: "Billing Status",
      key: "billingType",
      options: [
        {
          label: "Billed",
          value: "BILLED",
        },
        {
          label: "Un-Billed",
          value: "UNBILLED",
        }
      ],
    },
    {
      title: "Task Type",
      key: "taskType",
      options: [
        {
          label: "Recurring",
          value: "recurring",
        },
        {
          label: "Non-Recurring",
          value: "non_recurring",
        },
      ],
    },
  ];
};
